import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { WhiteBlock } from '~/shared/ui/Wrappers'

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`

export const CardBlock = styled(WhiteBlock)<{
  $disabled?: boolean
  $selected?: boolean
}>`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ $disabled }) => $disabled && 'pointer-events: none'};
  ${({ $disabled }) => $disabled && 'cursor: default'};
  ${({ $selected }) =>
    $selected && `outline: 1px solid ${myPalette.blue.main}`};
`
